<template>
    <button class="wizard-show-more-uploads" @click="handleShowMoreClick">
        {{ numberOfOptionalDocuments === maxNumberOfOptionalDocuments
            ? ''
            : 'Weiteres Diplom hochladen'
        }}
    </button>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        props: {
            maxNumberOfOptionalDocuments: {
                type: Number,
                required: true,
            },
        },
        computed: {
            ...mapState('wizard', ['numberOfOptionalDocuments']),
        },
        methods: {
            ...mapActions('wizard', ['updateNumberOfOptionalDocuments']),
            handleShowMoreClick() {
                this.updateNumberOfOptionalDocuments({ value: this.numberOfOptionalDocuments + 1 });
            },
        },
    };
</script>
